export default __webpack_public_path__ + "static/11-b5ee5ede6bb71be22a6f753dff3ed6e3.webp";